module.exports = __webpack_public_path__ + "img/icon-company-success.c266ffb3.svg";